import { render, staticRenderFns } from "./CalendarComponentB2C.vue?vue&type=template&id=25d83c82&"
import script from "./CalendarComponentB2C.vue?vue&type=script&lang=js&"
export * from "./CalendarComponentB2C.vue?vue&type=script&lang=js&"
import style0 from "./CalendarComponentB2C.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports